<template>

    <el-container class="wrapper">
        <el-scrollbar class="container-left" wrap-class="container-left-wrap" :class="{'slide-hide': isCollapse, 'slide-in-left': menuShow}">
            <div class="logo">
                <!--logo-->
                <!-- <img alt="element-logo" src="data:image/png;base64,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"> -->
                <p style="font-size: 20px;color: rgb(210, 115, 8);">EAS</p>
                <!--logo-->
                <span> </span>
            </div>
            <el-menu
                class="menu"
                :default-active="onRoutes"
                :collapse="isCollapse"
                style="border: none;"
                text-color="rgb(191, 203, 217)"
                background-color="rgb(48, 65, 86)"
                active-text-color="rgb(210, 115, 8)"
                unique-opened
                router>
                <sidebar-item v-for="item in routers" :key="item.path" :item='item' ></sidebar-item>
            </el-menu>
        </el-scrollbar>

        <el-container class="container-box" v-bind:class="{'slide-hide': isCollapse, 'slide-in-left': menuShow}">
            <el-header class="header">
                <div class="header-left">
                    <div class="header-toggle" @click="menuShow = !menuShow; showSideBar()">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                    <div class="slide-toggle" :class="{'slide-toggle-open': isCollapse}" @click="toggleSideBar">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
                <div class="header-tabs-box">
                    <el-breadcrumb class="app-levelbar" separator="/">
                        <el-breadcrumb-item v-for="(item,index)  in levelList" :key="item.path">
                        <span v-if='item.redirect==="noredirect"||index==levelList.length-1'
                              class="no-redirect">{{item.name}}</span>
                            <!-- <router-link v-else :to="item.redirect||item.path">{{item.name}}</router-link> -->
                        <span v-else style="font-weight: bold;color: #000;">{{item.name}}</span>
                        </el-breadcrumb-item>
                    </el-breadcrumb>
                </div>

                <div class="header-right">
                    <el-dropdown trigger="click">
                        <!--<i class="el-icon-setting" style="margin-right: 15px"></i>-->
                        <span>{{username.substr(0,7)}}{{username.length>7?'...':''}}<i class="el-icon-arrow-down el-icon--right"></i></span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item style="width:160px;"><div @click="handlePassword">Change Password</div></el-dropdown-item>
                            <el-dropdown-item style="width:160px;"><div @click="loginOut">Logout</div></el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>

                <!--add-->
                <el-dialog title="Change Password" :visible.sync="passwordFormVisible" width="85%" top="5vh">
                    <el-form :model="passwordFormData" :rules="passwordFormDataRules" ref="passwordFormData">
                        <el-form-item label="Original password" prop="oldPassword">
                            <el-input type="password" maxlength="20" v-model.trim="passwordFormData.oldPassword" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="New password" prop="newPassword">
                            <el-input type="password" maxlength="20" v-model.trim="passwordFormData.newPassword" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="Confirm password" prop="check_new_password">
                            <el-input type="password" maxlength="20" v-model.trim="passwordFormData.check_new_password" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click.native="passwordFormVisible = !passwordFormVisible">Cancel</el-button>
                        <el-button type="primary" @click.native="addSubmit('passwordFormData')" :loading="passwordLoading">Save</el-button>
                    </div>
                </el-dialog>

            </el-header>

            <div class="main-mask"
                 v-show="menuShow"
                 @click="menuShow = !menuShow"></div>

            <el-main class="main">

                <transition name="move" mode="out-in">
                    <router-view></router-view>
                </transition>
            </el-main>
        </el-container>
    </el-container>

</template>


<script>
import { mapGetters } from "vuex";
import SidebarItem from "./SidebarItem.vue";
import { password } from "../../api/auth/login";
import { getAdminId } from "../../utils/auth";
export default {
    data() {
        let validatePass = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("Please input a password"));
            } else {
                if (this.passwordFormData.check_new_password !== "") {
                    this.$refs.passwordFormData.validateField(
                        "check_new_password"
                    );
                }
                callback();
            }
        };
        let validatePass2 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("Please enter the password again"));
            } else if (value !== this.passwordFormData.newPassword) {
                callback(new Error("The two passwords are inconsistent!"));
            } else {
                callback();
            }
        };
        return {
            menuShow: false,
            levelList: null,
            passwordLoading: false,
            passwordFormVisible: false,
            passwordFormData: {
                oldPassword: "",
                newPassword: "",
                check_new_password: ""
            },
            passwordFormDataRules: {
                oldPassword: [
                    {
                        required: true,
                        message: "Please enter the original password",
                        trigger: "blur"
                    }
                ],
                newPassword: [
                    {
                        required: true,
                        message: "Please enter a new password",
                        trigger: "blur"
                    },
                    { validator: validatePass, trigger: "blur" }
                ],
                check_new_password: [
                    {
                        required: true,
                        message: "Please enter the password again",
                        trigger: "blur"
                    },
                    { validator: validatePass2, trigger: "blur" }
                ]
            }
        };
    },
    components: {
        SidebarItem
    },
    computed: {
        ...mapGetters({
            routers: "routers"
        }),
        onRoutes() {
            return this.$route.path;
        },
        username() {
            let username = this.$store.state.admin.userName;
            return !username ? this.name : username;
        },
        isCollapse() {
            return this.$store.state.app.sidebar.opened;
        }
    },
    mounted() {},
    methods: {
        toggleSideBar() {
            this.$store.dispatch("ToggleSideBar");
        },
        showSideBar() {
            this.$store.dispatch("ShowSideBar");
        },
        getBreadcrumb() {
            let matched = this.$route.matched.filter(item => item.name);
            const first = matched[0];
            // if (first && (first.name !== "Home" || first.path !== "")) {
            //     matched = [{ name: "Home", path: "/" }].concat(matched);
            // }
            this.levelList = matched;
        },
        loginOut() {
            this.$confirm("This operation will exit the system. Do you want to continue?", "Tips", {
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                type: "warning"
            })
                .then(() => {
                    this.$store.dispatch("loginOut").then(() => {
                        location.reload();
                    });
                })
                .catch(() => {
                });
        },
        // The password modification interface is displayed
        handlePassword() {
            this.passwordFormVisible = true;
            this.passwordFormData = {
                oldPassword: "",
                newPassword: "",
                check_new_password: ""
            };
        },
        addSubmit(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.passwordLoading = true;
                    let data = Object.assign({}, this.passwordFormData);
                    data.adminId = getAdminId();
                    password(data)
                        .then(res => {
                            this.passwordLoading = false;
                            if (res.code) {
                                this.$message({
                                    message: res.message,
                                    type: "error"
                                });
                            } else {
                                this.$message({
                                    message: "Successfully",
                                    type: "success"
                                });
                                // Refresh form
                                this.$refs["passwordFormData"].resetFields();
                                this.passwordFormVisible = false;
                                this.$store.dispatch("loginOut").then(() => {
                                    location.reload(); // To re instantiate the Vue router object and avoid bugs
                                });
                            }
                        })
                        .catch(() => {
                            this.$message({
                                type: "error",
                                message: "Failed"
                            });
                        });
                }
            });
        }
    },
    created() {
        this.getBreadcrumb();
    },
    watch: {
        $route() {
            this.getBreadcrumb();
        }
    }
};
</script>
<style type="text/scss" lang="scss">
@import "../../styles/mixin";
.el-header {
    /*background-color: #eef1f6;*/
    color: #333;
    padding: 0 10px;
}

.el-aside {
    color: #333;
}

.el-main {
    position: relative;
    padding: 0 10px 10px;
    background-color: #fff;
    margin-left: 7px;
    margin-top: 5px;
}
.main-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 200%;
    z-index: 100;
    background-color: #000;
    opacity: 0.3;
}

.move-enter-active,
.move-leave-active {
    transition: opacity 0.5s;
}

.move-enter,
.move-leave {
    opacity: 0;
}

.wrapper {
    height: 100%;
    overflow-y: hidden;
    background-color: #f5f7f9;
}

.container-box {
    height: 100%;
    transition: -webkit-transform 0.3s ease-in-out;
    transition: transform 0.3s ease-in-out, -webkit-transform 0.3s ease-in-out;
    overflow-y: auto;
}

.container-left {
    background-color: rgb(48, 65, 86);
    transition: left 0.23s ease-in-out;
    height: 100%;
    flex: 0 0 auto;
}
.container-left-wrap {
    overflow-x: hidden !important;
}

.container-left .svg-icon {
    font-size: 20px;
    margin-right: 5px;
}

.container-left:not(.slide-hide) {
    width: 200px;
}

.container-left.slide-hide {
    .logo img {
        display: none;
    }
    .logo span {
        display: inline-block;
    }
}

.menu {
    width: 100% !important;
}

/*.menu::-webkit-scrollbar{*/
/*display: none;*/
/*}*/

.header {
    position: relative;
    text-align: left;
    font-size: 12px;
    line-height: $header-height;
    border-bottom: 1px solid #d8dce5;
    background-color: #fff;
}

.logo {
    display: block;
    width: 100%;
    line-height: 80px;
    height: 80px;
    text-align: center;
    color: #fff;
    transition: display 0.7s ease-in-out;
    img {
        vertical-align: middle;
    }
    span {
        display: none;
    }
}

.header-left {
    display: inline-block;
    height: $header-height;
    overflow: hidden;
}

.header-tabs-box {
    display: inline-block;
    height: $header-height;
    max-width: 60%;
    overflow: hidden;
}

.header-right {
    display: flex;
    width: 100px;
    height: 100%;
    // margin-left: 10px;
    justify-content: flex-end;
    float: right;
    .el-dropdown {
        display: flex;
        cursor: pointer;
    }
    span {
        display: inline-block;
        @include text-overflow;
    }
    i {
        line-height: $header-height;
        margin-top: 2px;
    }
}

.app-levelbar {
    margin-left: 20px;
    line-height: 57px !important;
}

.slide-toggle {
    display: inline-block;
    height: $header-height;
    line-height: $header-height;
    text-align: center;
    cursor: pointer;
}

.slide-toggle span {
    display: inline-block;
    width: 2px;
    height: 12px;
    background-color: rgba(135, 141, 153, 0.8);
    margin-left: 5px;
}
.slide-toggle-open span {
    display: block;
    margin-left: 4px;
    margin-top: 4px;
    width: 16px;
    height: 2px;
}
.slide-toggle-open {
    padding-top: 17px;
}

@media screen and (min-width: 768px) {
    .main-mask {
        display: none;
    }
}

/*.slide-hide {*/
/*width: 64px !important;*/
/*}*/

@media screen and (max-width: 768px) {
    .main {
        overflow-y: scroll !important;
        -webkit-overflow-scrolling: touch;
    }

    .slide-hide.slide-in-left {
        -webkit-transform: translate3d(64px, 0, 0) !important;
        transform: translate3d(64px, 0, 0) !important;
    }
    .container-left.slide-hide.slide-in-left {
        left: -64px;
        width: 64px;
    }
    .container-left.slide-in-left {
        left: 0;
    }
    .container-left {
        margin-right: 0;
        opacity: 1;
        position: absolute !important;
        top: 0;
        left: -225px;
        z-index: 10;
        padding: 0;
    }

    .container-box.slide-in-left {
        min-width: 0;
        opacity: 1;
        -webkit-transform: translate3d(187px, 0, 0);
        transform: translate3d(187px, 0, 0);
        overflow: initial;
    }
    .header-toggle {
        display: block;
        /*background-color: #26a2ff;*/
        border-radius: 4px;
        /*border: 1px solid #fff;*/
        height: 40px;
        margin: 10px 0;
        padding: 2px 6px;
        outline: none;
        width: 40px;
        z-index: 10;
    }

    .header-toggle span {
        display: block;
        width: 100%;
        height: 4px;
        margin: 5px auto;
        background-color: rgba(135, 141, 153, 0.8);
    }

    .logo {
        display: none;
    }
    .slide-toggle {
        display: none;
    }
}
</style>
